import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreateDeliveryNoteLineDto {
  @Expose()
  quantity: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  unitPrice: number;

  @Expose()
  itemModelId?: string;

  @Expose()
  locationId?: string;

  @Expose()
  consumableId?: string;

  @Expose()
  serviceId?: string;

  @Expose()
  purchaseOrderLineId?: string;

  @Expose()
  serialNumber?: string;

  @Expose()
  notes?: string;
}
